import type { FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import TrophyIcon from 'app/icons/trophy_plain.svg';

import style from './style.module.scss';

interface Props {
  winnerName: string;
  // Board position of the winner: 0 = team 1 (left), 1 = team 2 (right).
  // Drives the trophy tint (design_team_1 / design_team_2), mirroring the
  // position-based team colors used across the grad NameBlock.
  winnerIndex: 0 | 1;
}

// Inter-game break overlay: floats over the live stats when a game in the
// series finishes but the match is still running. Translucent + blurred so the
// (now final) stats read faintly behind it. Grad analog of the default
// NameBlock's InterGameMessage, reusing the same i18n keys.
const InterGameBreak: FC<Props> = ({ winnerName, winnerIndex }) => {
  const { t } = useTranslation();

  return (
    <div
      className={classNames(style.interGameBreak, winnerIndex === 0 ? style.team1 : style.team2)}
    >
      <TrophyIcon className={style.trophy} />
      <p className={style.victory}>
        <strong className={style.winner}>{winnerName}</strong>{' '}
        {t('component_inbetween-game_victory', { defaultValue: 'takes the victory!' })}
      </p>
      <span className={style.divider} />
      <span className={style.break}>
        {t('component_inbetween-game_break', { defaultValue: 'Break' })}
      </span>
    </div>
  );
};

InterGameBreak.displayName = 'InterGameBreak';

export default InterGameBreak;
